import { createAsyncThunk } from '@reduxjs/toolkit';

import { axiosService } from 'services';
import { AXIOS_URLS } from 'config';

export const refresh = createAsyncThunk(
  'auth/refresh',
  async (_, { rejectWithValue }) => {
    try {
      const refreshToken = localStorage.getItem('refreshToken');

      const payload = await axiosService.post(`${AXIOS_URLS.auth}/refresh`, {
        refreshToken,
      });

      localStorage.setItem('accessToken', `Bearer ${payload.data.accessToken}`);
      localStorage.setItem('refreshToken', `${payload.data.refreshToken}`);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
